import React from 'react'
import { Typography, Button } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import { Box, styled } from '@mui/material'
import Survey64 from '@evocolabs/icons/lib/Survey64'

const content =
  'For an accurate fitting service tailored to your own needs, we invite you to fill out a quick survey, the results of which will be used for following services.'
const completedContent =
  'Thank you for taking the time to complete the survey. Results of the survey will be used by our support team to customize follow-up services delivered to you.'

const ActiveBox = styled(Box)`
  display: flex;
  flex-direction: row;
  border-radius: 12px 12px 0 0;
  padding: 8px 40px;
  align-items: center;
  justify-content: space-between;
`
const PrefittingEntrance = ({ prefittingStat }) => {
  function handleClick() {
    window.location.href = '/Survey/Prefitting'
  }

  return (
    <Box
      sx={{
        m: '16px 0',
        borderRadius: '12px'
      }}
    >
      <Box
        sx={{
          borderRadius: '0 0 12px 12px',
          backgroundColor: theme.palette.white.main,
          padding: '32px 40px',
          borderRadius: '12px',
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          [theme.breakpoints.down('md')]: {
            padding: '24px 16px'
          }
        }}
      >
        <Box display={'flex'}>
          <Box display={'flex'} flexDirection={'column'} gap={1}>
            <Box display={'flex'}>
              <Typography variant="T1">Pre-Fitting Survey</Typography>
              {!prefittingStat && (
                <div
                  style={{
                    width: '10px',
                    height: '10px',
                    backgroundColor: theme.palette.error[400],
                    borderRadius: '100%',
                    transform: 'translate(8px, 12px)'
                  }}
                />
              )}
            </Box>

            <Typography variant="body2">
              {prefittingStat ? completedContent : content}
            </Typography>
          </Box>
        </Box>
        {prefittingStat ? (
          <Button size="large" disabled>
            Survey Completed
          </Button>
        ) : (
          <Button
            id="account_service_center_start_prefitting_survey"
            size="large"
            handleClick={handleClick}
          >
            Let's Start Now
          </Button>
        )}
      </Box>
    </Box>
  )
}

const ActiveBoxMobile = styled(Box)`
  display: flex;
  flex-direction: row;
  border-radius: 12px 12px 0 0;
  padding: 8px 16px;
  align-items: center;
  justify-content: space-between;
`
const PrefittingEntranceMobile = ({ prefittingStat }) => {
  function handleClick() {
    window.location.href = '/Survey/Prefitting'
  }

  return (
    <Box
      sx={{
        mb: '16px',
        borderRadius: '12px'
      }}
    >
      <Box
        sx={{
          borderRadius: '0 0 12px 12px',
          backgroundColor: theme.palette.white.main,
          padding: '24px 16px 32px 16px'
        }}
      >
        <Typography variant="h3">Pre-Fitting Survey</Typography>
        <Typography variant="body1" style={{ letterSpacing: '-0.2px' }}>
          {prefittingStat ? completedContent : content}
        </Typography>
        {prefittingStat ? (
          <Button
            size="large"
            sx={{
              mt: '16px'
            }}
            disabled
          >
            survey completed
          </Button>
        ) : (
          <Button
            id="account_service_center_start_prefitting_survey"
            size="large"
            sx={{
              mt: '16px'
            }}
            handleClick={handleClick}
          >
            let's start now
          </Button>
        )}
      </Box>
    </Box>
  )
}

export { PrefittingEntrance, PrefittingEntranceMobile }
